import React from 'react'
import { priorityList } from './useMessagePriority'
import { FormattedMessage } from 'react-intl'
import { useField } from 'formik'
import {
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Input,
} from '@material-ui/core'
import clsx from 'clsx'

export default function MessagePrioritySelector(props) {
  const [field, meta, helpers] = useField(props.name)
  const { value } = meta
  const { setValue } = helpers
  const priorityOptions = priorityList(props.isEmergency)

  return (
    <FormControl
      className={clsx(props.className, 'w-full')}
      variant={props.variant}
      required={props.required}
      disabled={props.disabled}
    >
      {props.label && (
        <InputLabel htmlFor={props.name}>{props.label}</InputLabel>
      )}
      <Select
        {...field}
        value={value}
        disableUnderline={true}
        input={
          <Input
            id={props.name}
            className="p-14 h-48 rounded-8 border border-grey-input text-blue-950"
          />
        }
        onChange={(event) => {
          setValue(event.target.value)
        }}
      >
        <MenuItem disabled value="" className="text-blue-950">
          <FormattedMessage id="createNotification.dialog.selector.priority" />
        </MenuItem>

        {priorityOptions.map((item) => (
          <MenuItem key={item.id} value={item.id} className="text-blue-950">
            {item.display}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
